import { DocumentQuestion } from "store/types";
import { ShareDialog, IWindowSize, LeftSliderType, IView } from "../../types";
import { ViewAction } from "../actions";
import { AsyncActions, AsyncActionsParams } from "../base";
export interface IViewActions {
  commentsScrollAction: (value: boolean) => void;
  scrollToAnswerAction: (value: "on" | "off") => void;
  setShareDialog: (payload: ShareDialog | null) => void;
  setWindowSizeAction: (payload: IWindowSize) => void;
  setLeftSlider: (payload: LeftSliderType) => void;
  scrollToQuestionAction: (value: boolean) => void;
  emailBoxUpdateAction: (value: boolean) => void;
  setDealRedirectAction: (value: IView["dealRedirect"]) => void;
  setCrunchbaseStateAction: (value: boolean) => void;
  setCryptoCurrencyStateAction: (value: boolean) => void;
  setCreateManyMeasureData: (data: IView["createManyMeasureData"]) => void;
  setLogoutToAnotherDeviceAction: (value: string) => void;
  setSelectedQuestionAction: (value: DocumentQuestion | null) => void;
  setQuickViewAddNewLineAction: (value: boolean) => void;
  setIsDealCharBarOpenAction: (value: boolean) => void;
  setSidebarStateAction: (value: boolean) => void;
}
export class ViewActions extends AsyncActions implements IViewActions {
  public constructor(params: AsyncActionsParams) {
    super(params);
  }

  public commentsScrollAction = (value: boolean): void => {
    this.dispatch({ type: ViewAction.CommentsScroll, payload: value });
  };

  public scrollToAnswerAction = (value: "on" | "off"): void => {
    this.dispatch({ type: ViewAction.ScrollToAnswer, payload: value });
  };

  public setShareDialog = (payload: ShareDialog | null): void => {
    this.dispatch({
      type: ViewAction.SetShareDialog,
      payload
    });
  };

  public setWindowSizeAction = (payload: IWindowSize): void => {
    this.dispatch({ type: ViewAction.SetWindowSize, payload });
  };

  public setLeftSlider = (payload: LeftSliderType): void => {
    this.dispatch({ type: ViewAction.SetLeftSlider, payload });
  };

  public scrollToQuestionAction = (payload: boolean): void => {
    this.dispatch({ type: ViewAction.ScrollToQuestion, payload });
  };

  public emailBoxUpdateAction = (payload: boolean): void => {
    this.dispatch({ type: ViewAction.EmailBoxUpdate, payload });
  };

  public setDealRedirectAction: IViewActions["setDealRedirectAction"] = (payload) => {
    this.dispatch({ type: ViewAction.SetDealRedirect, payload });
  };

  public setCrunchbaseStateAction: IViewActions["setCrunchbaseStateAction"] = (payload) => {
    this.dispatch({ type: ViewAction.SetCrucnbaseDrawerState, payload });
  };

  public setCryptoCurrencyStateAction: IViewActions["setCryptoCurrencyStateAction"] = (payload) => {
    this.dispatch({ type: ViewAction.SetCryptoCurrencyDrawerState, payload });
  };

  public setCreateManyMeasureData: IViewActions["setCreateManyMeasureData"] = (payload) => {
    this.dispatch({ type: ViewAction.SetCreateManyMeasureData, payload });
  };

  public setLogoutToAnotherDeviceAction: IViewActions["setLogoutToAnotherDeviceAction"] = (payload) => {
    this.dispatch({ type: ViewAction.SetError409, payload });
  };

  public setSelectedQuestionAction = (payload: DocumentQuestion | null): void => {
    this.dispatch({ type: ViewAction.SetSelectedQuestion, payload });
  };

  public setQuickViewAddNewLineAction = (payload: boolean): void => {
    this.dispatch({ type: ViewAction.SetQuickViewAddNewLine, payload });
  };

  public setIsDealCharBarOpenAction = (payload: boolean): void => {
    this.dispatch({ type: ViewAction.SetIsDealCharBarOpen, payload });
  };

  public setSidebarStateAction = (payload: boolean): void => {
    this.dispatch({ type: ViewAction.SetSidebarState, payload });
  };
}
